<template>
  <!-- GRADIENT TOP -->
  <div
    class="absolute inset-x-0 top-0 h-1/4 bg-gradient-to-b from-[#011F2E] opacity-[0.73]"
  />

  <!-- GRADIENT BOTTOM -->
  <div
    class="absolute inset-x-0 bottom-0 h-2/3 bg-gradient-to-t from-[#022638] opacity-[0.92]"
  />
</template>
